<header class="cabecalho">
  <button type="button" class="cabecalho-btn-voltar" [class.cabecalho-btn-voltar-fixo]="mostrarVoltar" (click)="voltar.emit()" aria-label="Voltar para os contatos">
    <img src="./assets/icones/redesign/button/icon-back-title-button.svg" alt="" />
  </button>

  <button type="button" class="cabecalho-identidade" aria-label="Abrir perfil do contato" (click)="abrirPerfil.emit()">
  <div class="cabecalho-avatar-wrapper" [matTooltip]="tooltipFoto">
    <img class="cabecalho-avatar" [class.cabecalho-avatar-foto]="possuiFotoPerfil" [src]="fotoContato" alt="" (error)="marcarFotoIndisponivel()" />
    @if (logoCanalOrigem; as logo) {
      <img class="cabecalho-avatar-canal" [src]="logo" alt=""
          [class.cabecalho-avatar-canal-instagram]="contato.canalOrigem === CanalOrigemContatoEnum.INSTAGRAM" />
    }
  </div>

  <div class="cabecalho-info">
    <span class="cabecalho-nome-linha">
      <span class="cabecalho-nome" [title]="contato.nome || contato.contato">{{ contato.nome || contato.contato }}</span>
      @if (numeroVisivel()) {
        <span class="cabecalho-numero cabecalho-numero-lado" @revelar role="button" tabindex="0"
              [matTooltip]="numeroCopiado() ? 'Copiado!' : 'Copiar número'" aria-label="Copiar número do contato"
              (click)="copiarNumero($event)" (keydown.enter)="copiarNumero($event)">
          <span class="cabecalho-numero-separador" aria-hidden="true"></span>
          <span class="cabecalho-numero-texto" [class.cabecalho-numero-copiado]="numeroCopiado()">{{ contato.numero | celularMask }}</span>
        </span>
      }
      @if (podeVerNumero()) {
        <span class="cabecalho-btn-editar cabecalho-btn-telefone" role="button" tabindex="0"
              [class.cabecalho-btn-telefone-ligado]="numeroVisivel()"
              [attr.aria-label]="numeroVisivel() ? 'Ocultar número' : 'Mostrar número'" [attr.aria-pressed]="numeroVisivel()"
              [matTooltip]="numeroVisivel() ? 'Ocultar número' : 'Mostrar número'"
              (click)="alternarNumero($event)" (keydown.enter)="alternarNumero($event)">
          <span class="cabecalho-telefone-icones">
            <img src="./assets/icones/redesign/modulos/chat/details-contato/phone.svg" alt="" class="cabecalho-telefone-ligar" />
            <img src="./assets/icones/redesign/modulos/chat/details-contato/phone-off.svg" alt="" class="cabecalho-telefone-desligar" />
          </span>
        </span>
      }
      <span class="cabecalho-btn-editar" role="button" tabindex="0" aria-label="Editar contato" matTooltip="Editar contato"
            (click)="editarContato.emit(); $event.stopPropagation()" (keydown.enter)="editarContato.emit(); $event.stopPropagation()">
        <img src="./assets/icones/redesign/table/icon-edit-table.svg" alt="" />
      </span>
    </span>
    @if (numeroVisivel()) {
      <span class="cabecalho-numero cabecalho-numero-linha" @expandir role="button" tabindex="0"
            aria-label="Copiar número do contato" (click)="copiarNumero($event)" (keydown.enter)="copiarNumero($event)">
        <span class="cabecalho-numero-texto" [class.cabecalho-numero-copiado]="numeroCopiado()">
          {{ numeroCopiado() ? 'Número copiado!' : (contato.numero | celularMask) }}
        </span>
      </span>
    }
    @if (carregando) {
      <span class="cabecalho-janela-skeleton skeleton"></span>
    } @else {
      <span class="cabecalho-janela">
        <span class="cabecalho-janela-bolinha" [class.cabecalho-janela-bolinha-aberta]="tempoJanela()"></span>
        <span class="cabecalho-janela-curta">{{ tempoJanela() ? 'Janela: ' + tempoJanela() : 'Janela fechada' }}</span>
        <span class="cabecalho-janela-longa">{{ tempoJanela() ? 'Janela de resposta encerra em ' + tempoJanela() : 'Janela de resposta encerrada' }}</span>
      </span>
    }
  </div>
  </button>

  <div class="cabecalho-acoes">
    <button type="button" class="cabecalho-btn-icone cabecalho-btn-favorito"
            [class.cabecalho-favorito-ativo]="!!contato.favorito" [class.cabecalho-favorito-inativo]="!contato.favorito"
            [matTooltip]="contato.favorito ? 'Remover dos importantes' : 'Marcar como importante'"
            [attr.aria-pressed]="!!contato.favorito" (click)="alternarFavorito.emit()">
      <span class="cabecalho-estrela">
        <img src="./assets/icones/redesign/modulos/chat/filter/filter-fav-gray.svg" alt="" class="cabecalho-estrela-vazia" />
        <img src="./assets/icones/redesign/modulos/chat/filter/filter-fav-golden.svg" alt="" class="cabecalho-estrela-cheia" />
      </span>
    </button>

    <button type="button" class="cabecalho-lembretes" [class.cabecalho-lembretes-com-qtd]="qtdLembretes > 0" matTooltip="Lembretes do contato" (click)="abrirLembretes.emit()">
      <img src="./assets/icones/redesign/modulos/lembretes/icon-signal-lembrete.svg" alt="" />
      <span class="cabecalho-lembretes-qtd">
        @for (qtd of [qtdLembretes]; track qtd) {
          <span class="cabecalho-lembretes-numero">{{ qtd }}</span>
        }
      </span>
    </button>

    <button type="button" class="cabecalho-btn-icone cabecalho-btn-detalhes" matTooltip="Detalhes do contato"
            aria-label="Abrir detalhes do contato" (click)="abrirPerfil.emit()">
      <img src="./assets/icones/redesign/modulos/chat/details-contato/open-details.svg" alt="" />
    </button>
  </div>
</header>
